import type { Message, MessageAttachment } from './types'

export function isImageMimeType(mimeType: string): boolean {
  return mimeType.startsWith('image/')
}

function asRecord(raw: unknown): Record<string, unknown> {
  return raw && typeof raw === 'object' ? (raw as Record<string, unknown>) : {}
}

export function normalizeAttachment(raw: unknown, chatId: number): MessageAttachment {
  const record = asRecord(raw)
  const attachmentId = Number(record['id'] ?? 0)
  const mimeType = String(record['mime_type'] ?? 'application/octet-stream')

  return {
    id: attachmentId,
    filename: String(record['filename'] ?? ''),
    original_name: String(record['original_name'] ?? record['filename'] ?? ''),
    mime_type: mimeType,
    size: Number(record['size'] ?? 0),
    url: `/api/chats/${chatId}/files/${attachmentId}`,
    thumbnail_url: isImageMimeType(mimeType)
      ? `/api/chats/${chatId}/files/${attachmentId}/thumbnail`
      : null,
    created_at:
      typeof record['created_at'] === 'string' ? record['created_at'] : new Date().toISOString(),
  }
}

export function normalizeMessage(raw: unknown, chatId: number): Message {
  const record = asRecord(raw)
  const author = asRecord(record['author'])
  const attachmentsRaw = Array.isArray(record['attachments']) ? record['attachments'] : []

  return {
    id: Number(record['id']),
    content: String(record['content'] ?? ''),
    type: String(record['type'] ?? 'text'),
    author: {
      id: Number(author['id'] ?? 0),
      name: String(author['full_name'] ?? author['name'] ?? ''),
    },
    attachments: attachmentsRaw
      .filter((item): item is Record<string, unknown> => !!item && typeof item === 'object')
      .map((item) => normalizeAttachment(item, chatId)),
    created_at:
      typeof record['created_at'] === 'string' ? record['created_at'] : new Date().toISOString(),
  }
}

export function isVisibleChatMessage(raw: unknown): boolean {
  const record = asRecord(raw)
  return !(record['type'] === 'system' && record['content'] === 'file_uploaded')
}
